<template lang="html">
  <error-page-layout
    error-type="Sessão expirada"
    color-type="error"
    title="Sua sessão expirou"
    first-message="Você ficou inativo por muito tempo ou entrou com essa conta em outro dispositivo e foi desconectado por motivos de segurança."
    image-name="expired.png"
  >
    <mf-button slot="buttons" text color="orange" label="Fazer login novamente" @click="redirect" />
  </error-page-layout>
</template>

<script>
import { formattedRedirectLogout } from '@/helpers/login'
import ErrorPageLayout from '@/components/ErrorPageLayout.vue'
// import { wsClient, wsClientHulk } from '@/services/webSocket'

export default {
  components: {
    ErrorPageLayout,
  },
  created() {
    // wsClient.dispose()
    // wsClientHulk.dispose()
  },
  methods: {
    async redirect() {
      const singleLoginURL = this.$microservicesUrls['mfLogin']
      const host = location.href.slice(0, location.href.indexOf('#'))
      const hash = window.localStorage.getItem('redirectAfterLogin') || ''

      this.$logout()
      window.location.href = formattedRedirectLogout(singleLoginURL, host, hash)
    },
  },
}
</script>
